export const STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  DEMO: "demo",
  BETA: "beta",
  NEW: "new",
};

export const ENVIRONMENTS = {
  PRODUCTION: "PRODUCTION",
  STAGING: "STAGING",
  SANDBOX: "SANDBOX",
  DEMO: "DEMO",
  TEST: "TEST",
  LOCAL: "LOCAL",
  LOCAL_NGINX: "LOCAL_NGINX",
};

export const MODULES = {
  DASHBOARD: "DASHBOARD",
  CASES: "CASES",
  TICKETS: "TICKETS",
  CHATS: "CHATS",
  CONTACTS: "CONTACTS",
  SOCIALS: "SOCIALS",
  ECOMMERCE: "ECOMMERCE",
  ONCALL: "ONCALL",
  STATISTICS: "STATISTICS",
  INTEGRATIONS: "INTEGRATIONS",
  FILE_MANAGER: "FILE_MANAGER",
  CAMPAIGNS: "CAMPAIGNS",
  FORMS: "FORMS",
  CALENDAR: "CALENDAR",
  BOTS: "BOTS",
  RULES: "RULES",
  WORKFLOW: "WORKFLOW",
  SOFTPHONE: "SOFTPHONE",
  CONTACT_CENTER: "CONTACT_CENTER",
  CONFIGURATION: "CONFIGURATION",
  AUTOMATION: "AUTOMATION",
  MONITORING: "MONITORING",
  AI_ASSISTANTS: "AI_ASSISTANTS",
  PII_MANAGEMENT: "PII_MANAGEMENT",
};
